<template>
    <div class="animated fadeIn">
        <Forms
          ref="frmGroup"
          :title="'CADASTRO DE GRUPOS'"
          :showClearButton="true"
          :showSaveButton="true"
          :showBackButton="true"
          v-on:Clear="onClear"
          v-on:Back="onBack"
          v-on:Save="onSave"
        >
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtName">
                <small v-show="form.nameGroup.required" class="text-danger">*</small>
                  {{ $lang.GroupsConfig.LabelGroup }}:
              </label>
              <div class="input-group">
                <b-form-input
                  type="text"
                  :placeholder="$lang.GroupsConfig.PlaceholderEnterGroupName"
                  v-model="form.nameGroup.value"
                  :size="form.nameGroup.maxlength"
                  :required="form.nameGroup.required"
                  :state="form.nameGroup.state"
                ></b-form-input>
              </div>
            </div>
          </div>

          <UsersTable
            ref="UsersTable"
            :idFuncionarios="idFuncionarios"
            @UpdateGroupList="updateGroupList"
            class="pt-4"
          ></UsersTable>
        </Forms>
    </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import GroupModel from '@/shared/models/configurations/groupmodel.js'
import GroupForms from './group-form.js'
import UsersTable from '../usersTable/userstable.vue'
import GroupRepository from '@/shared/http/repositories/configurations/group.js'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'GroupAdd',
  mixins: [ActionsForm],
  components: {
    UsersTable
  },
  data () {
    return {
      editMode: false,
      data: GroupModel,
      form: GroupForms,
      usersList: [],
      usersAlreadyWithPermission: [],
      idFuncionarios: new Set()
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      this.editMode = true
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.nameGroup.value = obj.nameGroup
      this.form.inative.value = obj.inative

      if (obj.usuarioGroup) {
        obj.usuarioGroup.forEach(x => {
          this.idFuncionarios.add(x.id)
        })
      }
      loading.pop()
    },
    onCreate () {
      if (this.data.nameGroup) {
        loading.push()
        this.data.usuarioGroupId = this.usersAlreadyWithPermission.map((x) => x.id)
        GroupRepository.Create(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(e => advancedOnException(e, this.$lang))
      }
    },
    onUpdate () {
      if (this.data.nameGroup) {
        loading.push()
        this.data.id = parseInt(this.data.id)
        this.data.usuarioGroupId = this.usersAlreadyWithPermission.map((x) => x.id)
        GroupRepository.Update(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(e => advancedOnException(e, this.$lang))
      }
    },
    updateGroupList (leftTable, rightTable) {
      this.usersList = leftTable
      this.usersAlreadyWithPermission = rightTable
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/group/components/add/groupadd.vue